import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const WaistCircumferencePage = lazy(() => import("./WaistCircumferencePage"));

const WaistCircumferencePageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <WaistCircumferencePage />
    </Suspense>
  );
};

export default WaistCircumferencePageLazy;
